/// <reference types="@welldone-software/why-did-you-render" />
import React from 'react';

declare const WDYR_ENABLED: string;

const exclude = [/[A-Z][A-Za-z]*Icon$/];

if (process.env.NODE_ENV === 'development' && WDYR_ENABLED === 'true') {
  const whyDidYouRender = require('@welldone-software/why-did-you-render');
  whyDidYouRender(React, {
    trackAllPureComponents: true,
    exclude,
  });
}
